import styled, {keyframes} from "styled-components";

export const CircularSVG = styled.svg`
  animation: "rotate 2s linear infinite";
  height: 25px;
  position: relative;
  width: 25px;
`;


const dash = keyframes`
  0%{
   stroke-dasharray: 1,200;
   stroke-dashoffset: 0;
  }
  50%{
   stroke-dasharray: 89,200;
   stroke-dashoffset: -35;
  }
  100%{
   stroke-dasharray: 89,200;
   stroke-dashoffset: -124;
  }
`;



export const CustomCircle = styled.circle`
  stroke-dasharray: 600;
  stroke-dashoffset: 0;
  stroke: grey;
  animation: ${dash} 1s ease-in infinite;
  stroke-linecap: round;
`;
